import { render, staticRenderFns } from "./BlurredBackdrop.vue?vue&type=template&id=708956c6&scoped=true&"
import script from "./BlurredBackdrop.vue?vue&type=script&lang=js&"
export * from "./BlurredBackdrop.vue?vue&type=script&lang=js&"
import style0 from "./BlurredBackdrop.vue?vue&type=style&index=0&id=708956c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708956c6",
  null
  
)

export default component.exports